import axios from 'axios';

const BASE_URL = 'https://ecommerce-api-l3as.onrender.com/api/v1/';

export const publicRequest = axios.create({ baseURL: BASE_URL });

export const userRequest = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
